import { Exercise, ExerciseFormat } from '../exercise';

export class UserWorkoutPause {
    // starts at 1
    public stage: number;
    public pauseType: ExerciseFormat;
    public constructor(stage: number, pauseType: ExerciseFormat | undefined) {
        if (pauseType == null || !Exercise.isPauseFormat(pauseType)) {
            throw Error('Expected format ' + pauseType + ' to be a pause type format');
        }
        this.stage = stage;
        this.pauseType = pauseType == null ? ExerciseFormat.DanceMove : pauseType;
    }
}
